import React, {Component} from "react";
import ReactDOM from "react-dom";
import Overlay from '../../components/Overlay'
import { Helmet } from 'react-helmet'
import { compose, lifecycle, withState, withHandlers } from 'recompose'
import { injectIntl } from 'react-intl'

export const Charity = ({success, setSum, sum, cloudPayment, buttonShow,setButtonShow, setSumForPay}) => {

  let showInput = false

  let contentSuccess = `
	<div style="padding-top:16px; padding-left:25px; padding-right:25px; position:relative; z-index:3; font-family:Arial; color:#ff5027; ">
        <div class="modal_dr_2" style="color: white" >Благодарим вас за поддержку!</div>
        <div style={{backgroundColor: "white", height: "50px"}}>
          <a class='mfc-modal__btn-submit-charity-white' onClick={window.open('/charity','_self')}>Вернуться на форму</a>
        </div>        
    </div>
`
  let contentFail = `
  <div style="padding-top:16px; padding-left:25px; padding-right:25px; position:relative; z-index:3; font-family:Arial; color:#ff5027; ">
        <div class="modal_dr_2" style="color: white" >Оплата не успешна, попробуйте еще раз</div>
    </div>
  `

  function changeSum(sum) {
    showInput = true
    document.getElementById('sum').className = "mfc-modal__input-charity"
    document.getElementById(sum).className = "mfc-modal__btn-radio-charity-checked"
    setButtonShow(false)
  }
    
  return (
  <div className='Donate'>
  <div className='Container Container_light'>
    <Helmet>
      <title>MeetForCharity</title>
    </Helmet>
    <Overlay isActive={true}  klassModifier={"mfc-modal_3"} >
      <form name='form'>
        <div className="mfc-modal-content-charity donate">
          
          <div className="mfc-modal__input-charity-wrapper">
            <label htmlFor="sum">Сумма пожертвования</label>
            <div className='mfc-modal__btn-radio-group-charity'>
            <a className='mfc-modal__btn-radio-charity' id="50000" value="50000" onClick={setSumForPay(50000)}>50 000 ₽</a>
            </div>
            <div className='mfc-modal__btn-radio-group-charity'>
            <a className='mfc-modal__btn-radio-charity' id="100000" onClick={setSumForPay(100000)}>100 000 ₽</a>
            </div>          
            <div className='mfc-modal__btn-radio-group-charity'>
              {<input
                className='mfc-modal__input-charity-none'
                type="number"
                name="sum"
                id="sum"
                min="1"
                onChange={(e) => setSum(e.target.value)}
                onKeyDown={cloudPayment}
                placeholder="Введите сумму пожертвования"
                required
              />}
              {buttonShow &&<a className='mfc-modal__btn-radio-charity' id="other" onClick={() => changeSum('other')}>Другая сумма</a>}
            </div>
          </div>
        </div>
        <div className="mfc-modal-content-charity donate">
          {sum && <div style={{backgroundColor: "white", height: "50px"}}>
            <a className='mfc-modal__btn-submit-charity' onClick={setSumForPay()}>Помогаю!</a>
          </div>}
        </div>
      </form>
    </Overlay>

  {(success === true) && <Overlay isActive={true}>
	  <div dangerouslySetInnerHTML={{__html: contentSuccess}} />	
  </Overlay>}

  {(success === false) && <Overlay isActive={true}>
	  <div dangerouslySetInnerHTML={{__html: contentFail}} />	
  </Overlay>}
	
  </div>
  </div>
)
}

export default injectIntl(compose(
  withState('success', 'setSuccess', undefined),
  withState('sum', 'setSum', undefined),
  withState('buttonShow', 'setButtonShow', true),
  withState('checked', 'setChecked', undefined),
  withHandlers({
    cloudPayment: ({setSuccess, sum}) => element =>  {
      if (element.keyCode == 13) {
        element.preventDefault()
      }
      //sum - сумма, введенная пользователем // element - из setSumForPay (по нажатию кнопок)
      //Если функция вызвана из setSumForPay, то element - сумма к оплате
      //Если функция вызвана непосредственно с формы (<Input onKeyDown=), element - event, а значение берется из sum
      let sumToPay = sum
      if (element && typeof element == 'number') {
        sumToPay = element
      }
      if ((Number(sumToPay) > 0) && (!element.keyCode || element.keyCode == 13)) {
      var widget = new window.cp.CloudPayments();
        widget.charge({ // options
            publicId: 'pk_add0a933b426de0cfd4c172b25cc0',  //id из личного кабинета//pk_911493df6e01ea277b3d38e265cfc боевой pk_add0a933b426de0cfd4c172b25cc0
            description: 'Пожертвование', //назначение
            amount: Number(sumToPay), //сумма
            currency: 'RUB', //валюта
            invoiceId: '1234567', //номер заказа  (необязательно)
            //accountId: name,//'user@example.com', //идентификатор плательщика (необязательно)
            skin: "mini", //дизайн виджета
            data: {
              myProp: 'charitypage' //произвольный набор параметров
            }
          },
          function (options) { // success
            setSuccess(true)
          },
          function (reason, options) { // fail
            console.log('reason', reason)
            if (reason != 'User has cancelled') {
              setSuccess(false)
              setTimeout(() => {
                setSuccess(undefined);
              }, 2000)
            }
          });
        }
    },
  }),
  withHandlers({
    setSumForPay: ({sum, cloudPayment}) => value => element => {
      let sumToPay = sum//при нажатии на кнопку Помогаю! (выборе своей суммы)
      if (value) {
        sumToPay = value //при нажатии на кнопку с фикс суммой
      }
      if (Number(sumToPay) > 0) {
        cloudPayment(sumToPay)
      }
    },
  })
)(Charity))


// WEBPACK FOOTER //
// ./src/containers/Donate/Charity.jsx